import styled from 'styled-components'

import { Colours } from '@lib/theme'

interface Props {
  title: string
  subtitle: string
  onClick: () => void
}

export const ResultList = styled.ul`
  padding: 0;
`

const RowContainer = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  :hover {
    background-color: #fff;
  }
`

const InnerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  cursor: pointer;

  > div {
    flex: 1 1 0;
    width: 100%;
  }

  h5,
  small {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  small {
    font-size: 0.7rem;
  }

  h5 {
    margin: 0;
    color: ${Colours.FgShade.Dark};
    font-weight: bold;
    font-size: 0.8rem;
  }
`

export function SearchResultRow({ title, subtitle, onClick }: Readonly<Props>) {
  return (
    <RowContainer id={`record-result-${title}`} onClick={() => onClick()}>
      <InnerRow>
        <div>
          <h5>{title}</h5>
        </div>
      </InnerRow>

      <InnerRow>
        <small>{subtitle}</small>
      </InnerRow>
    </RowContainer>
  )
}
